export enum PosTabsType {
  Cafe,
  FrontDesk,
  SelfServe,
  None,
}
